import React from 'react';
import './FinalCTA.css';

export function FinalCTA() {
  return (
    <section className="final-cta">
      <div className="cta-content">
        <h2 className="cta-title">The next chapter of your career begins here.</h2>
        <p className="cta-subtitle">Join professionals who grow with us.</p>
        <div className="cta-actions">
          <button className="btn btn-primary cta-btn">Enroll Now</button>
          <button className="btn btn-secondary cta-btn">Learn More</button>
        </div>
      </div>
      
      <div className="cta-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </section>
  );
}
